import React from 'react';
import dayjs from "dayjs";

const Template1BLocalisation = (props) => {

    return (
        <div className="ue-section ue-localisation">
            <p><span className="ue-font-weight-7">Localisation</span> (Source cadastre Etalab {dayjs().format('YYYY')})</p>
            <img src={props.screenCapt} alt={'Localisation'} width="100%" />
        </div>
    )
};

export default Template1BLocalisation;
